import { VanityReport } from "@/types/vanity"
import {
  CaseReducer,
  createSelector,
  createSlice,
  PayloadAction,
} from "@reduxjs/toolkit"

import { RootState } from "./redux-store"

export const CreateTabLinksType = "links"
export const CreateTabGuidesType = "guides"
export const CreateTabEarningsType = "earnings"
export const CreateTabCommissionsType = "commissions"
export const CreateTabThatchCommissionsType = "thatch_commissions"

export const CreateTabTypeList = [
  CreateTabLinksType,
  CreateTabGuidesType,
  CreateTabEarningsType,
  CreateTabCommissionsType,
  CreateTabThatchCommissionsType,
]

export type CreateTabType =
  | typeof CreateTabLinksType
  | typeof CreateTabGuidesType
  | typeof CreateTabEarningsType
  | typeof CreateTabCommissionsType
  | typeof CreateTabThatchCommissionsType

export const AdminTabDraftsType = "drafts"
export const AdminTabPublishedType = "published"
export const AdminTabReportType = "report"
export const AdminTabEarningsType = "earnings"
export const AdminTabCreatorsType = "creators"

export const AdminTabTypeList = [
  AdminTabDraftsType,
  AdminTabPublishedType,
  AdminTabReportType,
  AdminTabEarningsType,
  AdminTabCreatorsType,
]

export type AdminTabType =
  | typeof AdminTabDraftsType
  | typeof AdminTabPublishedType
  | typeof AdminTabReportType
  | typeof AdminTabEarningsType
  | typeof AdminTabCreatorsType

export interface CreatorSliceState {
  currShortUrl: VanityReport | undefined
  createTab: CreateTabType
  adminTab: AdminTabType
}

export const creatorSliceInitialState: CreatorSliceState = {
  currShortUrl: undefined,
  createTab: CreateTabGuidesType,
  adminTab: AdminTabDraftsType,
}

export const selectCreatorState = (state: RootState) => state.creatorSlice

export const selectCurrShortUrl = createSelector(
  [selectCreatorState],
  (creatorState) => creatorState.currShortUrl
)

export const selectShowVanityLinkDialog = createSelector(
  [selectCreatorState],
  (creatorState) => !!creatorState.currShortUrl
)

export const selectCreateTab = createSelector(
  [selectCreatorState],
  (creatorState) => creatorState.createTab
)

export const selectAdminTab = createSelector(
  [selectCreatorState],
  (creatorState) => creatorState.adminTab
)

const setCurrShortUrl: CaseReducer<
  CreatorSliceState,
  PayloadAction<VanityReport | undefined>
> = (state, action) => {
  state.currShortUrl = action.payload
}

const setCreateTab: CaseReducer<
  CreatorSliceState,
  PayloadAction<CreateTabType>
> = (state, action) => {
  state.createTab = action.payload
}

const setAdminTab: CaseReducer<
  CreatorSliceState,
  PayloadAction<AdminTabType>
> = (state, action) => {
  state.adminTab = action.payload
}

const creatorSlice = createSlice({
  name: "creator",
  initialState: creatorSliceInitialState,
  reducers: {
    setCurrShortUrl,
    setCreateTab,
    setAdminTab,
  },
})

export type CreatorSlice = typeof creatorSlice

export default creatorSlice
